"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { Suspense, useEffect, useState } from "react";

interface ThirdPartyToggleProps {
  className?: string;
}

function ThirdPartyToggleInner({ className = "" }: ThirdPartyToggleProps) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [isThirdParty, setIsThirdParty] = useState(false);

  // Check for 3rdparty parameter on mount
  useEffect(() => {
    const thirdParty = searchParams?.get("3rdparty") === "true" || sessionStorage.getItem("3rdparty") === "true";
    setIsThirdParty(thirdParty);
  }, [searchParams]);

  const handleToggleThirdParty = () => {
    const newValue = !isThirdParty;
    setIsThirdParty(newValue);

    // Update URL and sessionStorage
    const url = new URL(window.location.href);
    if (newValue) {
      url.searchParams.set("3rdparty", "true");
      sessionStorage.setItem("3rdparty", "true");
    } else {
      url.searchParams.delete("3rdparty");
      sessionStorage.removeItem("3rdparty");
    }
    router.push(url.pathname + url.search);
  };

  return (
    <div className={`bg-white rounded-lg shadow-lg border border-gray-200 p-3 ${className}`}>
      <label className="flex items-center gap-2 cursor-pointer">
        <input type="checkbox" checked={isThirdParty} onChange={handleToggleThirdParty} className="sr-only" />
        <div
          className={`relative w-11 h-6 rounded-full transition-colors ${
            isThirdParty ? "bg-indigo-600" : "bg-gray-300"
          }`}
        >
          <div
            className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform ${
              isThirdParty ? "translate-x-5" : "translate-x-0"
            }`}
          />
        </div>
        <span className="text-sm font-medium text-gray-700">For 3rd Party Agencies</span>
      </label>
    </div>
  );
}

export default function ThirdPartyToggle({ className }: ThirdPartyToggleProps) {
  return (
    <Suspense
      fallback={
        <div className={`bg-white rounded-lg shadow-lg border border-gray-200 p-3 ${className}`}>
          <div className="w-40 h-6 bg-gray-200 rounded animate-pulse" />
        </div>
      }
    >
      <ThirdPartyToggleInner className={className} />
    </Suspense>
  );
}
